import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setFavourite } from '../redux/userSlice';

const FavouriteIcon = ({ activityId, isBig }) => {
    const userId = useSelector(state => state.user.id);
    const { favourites, isLogged } = useSelector(state => state.user);
    const [isFavourite, setIsFavourite] = useState(false)
    // Con questo useEffect setIsFavourite viene gestito sempre automaticamente dalla presenza dell'attività in redux
    useEffect(() => {
        if (userId && favourites) {
            if (favourites.includes(activityId)) {
                setIsFavourite(true)
            } else {
                setIsFavourite(false)
            }
        }
    }, [userId, favourites])
    const dispatch = useDispatch();
    const sendSetFavourite = async () => {
        try {
            const token = localStorage.getItem('ticino-wild-token');
            const url = `${process.env.REACT_APP_SERVER_BASE_URL}/users/set-favourite`;
            const headers = {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            };
            const options = {
                method: 'POST',
                headers,
                body: JSON.stringify({ userId, activityId, isFavourite: !isFavourite })
            }
            const response = await fetch(url, options);
            if (response.ok) {
                const result = await response.json();
                dispatch(setFavourite({ activityId: result.payload.activityId, isFavourite: result.payload.isFavourite}));
            } else {
                const error = await response.json();
                throw error;
            }
        } catch (error) {
            console.log('Favourite error: ', error)
        }
    }
    return (
        <div className={`
            ${!isLogged ? 'hidden' : ''}
            rounded-full
            ${isBig ?
                'w-12 h-12 text-xl border border-[#225424]' :
                'w-12 h-12 md:w-6 md:h-6 text-xl md:text-xs'}
                bg-white text-[#b05704] flex justify-center
                items-center pt-[5px] cursor-pointer
                md:hover:scale-110
                transform transition-transform duration-300`} onClick={sendSetFavourite}>
            {
                userId && activityId &&
                <div>
                    {isFavourite && <i className="fi fi-sr-heart"></i>}
                    {!isFavourite && <i className="fi fi-rr-heart"></i>}
                </div>
            }
        </div>
    )
}

export default FavouriteIcon;